import { useLingui } from '@lingui/react/macro';

import { Error } from './error';

export type ErrorPageProps = {
  error: unknown;
};

export function ErrorPage({ error }: ErrorPageProps) {
  const { t } = useLingui();

  return (
    <Error
      statusCode={500}
      title={t`Error`}
      description={t`Something went wrong.`}
    />
  );
}
